import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API}/blogs?published_only=true`);
        setBlogs(response.data);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="pt-20" data-testid="blog-page">
      {/* Hero */}
      <section className="bg-[#1e3a5f] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <p className="text-[#c9a227] uppercase tracking-[0.2em] text-sm font-semibold mb-4">
              Blog
            </p>
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold text-white mb-6">
              Nos Articles
            </h1>
            <p className="text-gray-300 text-lg leading-relaxed">
              Conseils, actualités et analyses sur la division immobilière, 
              l'indivision et l'investissement immobilier.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="w-8 h-8 border-4 border-[#1e3a5f] border-t-transparent rounded-full loading-spinner"></div>
            </div>
          ) : blogs.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogs.map((blog, index) => (
                <Link 
                  key={blog.id}
                  to={`/blog/${blog.slug}`}
                  className="group blog-card bg-white border border-gray-100 overflow-hidden"
                  data-testid={`blog-card-${index}`}
                >
                  <div className="img-zoom">
                    <img 
                      src={blog.image_url || 'https://images.unsplash.com/photo-1657129208507-7005dfc5b36a?w=800'}
                      alt={blog.title}
                      className="w-full h-56 object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="text-[#c9a227] text-xs uppercase tracking-wider font-semibold">
                        {blog.category}
                      </span>
                      <span className="flex items-center gap-1 text-gray-400 text-xs">
                        <Calendar size={12} />
                        {formatDate(blog.created_at)}
                      </span>
                    </div>
                    <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1e3a5f] mb-3 group-hover:text-[#c9a227] transition-colors">
                      {blog.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                      {blog.excerpt}
                    </p>
                    <span className="inline-flex items-center text-[#1e3a5f] text-sm font-semibold group-hover:text-[#c9a227] transition-colors">
                      Lire la suite
                      <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-gray-500 text-lg">Aucun article pour le moment.</p>
              <p className="text-gray-400 mt-2">Revenez bientôt pour découvrir nos contenus.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;
